var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { on: { dblclick: _vm.handleDoubleClick } },
    [
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.SQLvalue,
            expression: "SQLvalue"
          }
        ],
        ref: "sqlEditor",
        staticClass: "sql-editor",
        attrs: { placeholder: _vm.$t("Home.pleaseEnter") },
        domProps: { value: _vm.SQLvalue },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.SQLvalue = $event.target.value
          }
        }
      }),
      _vm.isFormattingSQL
        ? _c(
            "el-button",
            {
              staticStyle: { margin: "10px 0 0 0" },
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.formatSQL }
            },
            [_vm._v("格式化 SQL")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }